import React from 'react';
import Navbar from '../components/navbar/Navbar';
import Footer from '../components/Footer';

interface ContentLayoutProps {
    children: React.ReactNode;
    footer?: boolean;
}

const ScrollableContentLayout: React.FC<ContentLayoutProps> = ({ footer = true, children }) => (
  <div className="flex flex-col min-h-screen bg-base-100">
    <Navbar />
    <main className="flex-grow relative">
      {children}
    </main>
    {footer && <Footer />}
  </div>
);

ScrollableContentLayout.defaultProps = {
  footer: true,
};

export default ScrollableContentLayout;
